import { GetCardCategoryModel } from "@factory/model/query-model-card-category";

import { cardCategoryFormDefault } from "./form.default";
import { CardCategoryFormSchema } from "./form.rule";

export const useFormDefaultCardCategory = () => {
  const getDefault = (cachedValue: GetCardCategoryModel | undefined) => {
    return !cachedValue
      ? cardCategoryFormDefault
      : ({
          name: cachedValue.name,
          description: cachedValue.description,
          tenant: cachedValue.tenant,
          expirationYears: cachedValue.expiration_years,
        } as CardCategoryFormSchema);
  };

  return {
    getDefault,
  };
};
